import React, { PropsWithChildren } from "react";
import Error, { ErrorCodes } from "areas/layout/components/Error";
import { datadogLogs as datadog } from "@datadog/browser-logs";

interface ErrorBoundaryProps extends PropsWithChildren {}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Defines Error Boundary component for the app. Unfortunately it can't be a
 * function component and has to be a class component.
 */
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any) {
    datadog.logger.error(`Rendering error: `, error);
    console.error(`Rendering error: `, error);
  }

  render() {
    if (this.state.hasError) {
      return <Error errorCode={ErrorCodes.GeneralError} alreadyLogged={true} />;
    }
    return this.props.children;
  }
}
